/* global $ window Modernizr */

$('.slider').each(function() {
    const $slider         = $(this)
    const $header         = $slider.find('.slider-header')
    const $sWindow        = $slider.find('.slider-window')
    const $buttons        = $header.find('button')
    const $lis            = $header.find('li')
    const $items          = $slider.find('.slider-item')
    const $next           = $slider.find('.slider-next')
    const $prev           = $slider.find('.slider-prev')
    const $mobileDotsWrap = $('<div class="mobile-dots" />').appendTo($header)

    $items.each(() => {
        $mobileDotsWrap.append($("<span />"))
    })

    const $mobileDots = $mobileDotsWrap.children()

    let busy        = false
    let activeIndex = 0
    let timeout     = 0
    let isMobile    = false

    const slideTo = (index, direction = null) => {
        let fadeInClass
        let fadeOutClass

        if (activeIndex === index || busy) {
            return
        }

        busy = true

        $lis.removeClass('active').eq(index).addClass('active')

        // Work out whether we need to go left or right
        // 1 for next / going right (content moves left)
        // -1 for previous / going left (content moves right)
        if (direction === null) {
            direction = index > activeIndex ? 1 : -1
        }

        if (direction === 1) {
            fadeInClass  = 'fadeInRight'
            fadeOutClass = 'fadeOutLeft'
        } else {
            fadeInClass  = 'fadeInLeft'
            fadeOutClass = 'fadeOutRight'
        }

        $items.eq(activeIndex).removeClass('fadeInRight fadeInLeft active').addClass(fadeOutClass)
        $items.eq(index).removeClass('fadeOutRight fadeOutLeft').addClass(fadeInClass)

        $mobileDots.eq(activeIndex).removeClass('active')
        $mobileDots.eq(index).addClass('active')

        activeIndex = index

        window.setTimeout(() => {
            busy = false
        }, 400)
    }

    $buttons.each((buttonIndex, button) => {
        const $btn = $(button)

        // Store the default text
        $btn.data('text-desktop', $btn.text())

        // Bind click
        $btn.click(() => slideTo(buttonIndex))
    })

    $next.click(() => {
        slideTo(activeIndex + 1 >= $items.length ? 0 : activeIndex + 1, 1)
    })

    .on('touchstart', () => $next.addClass('touch'))
    .on('touchend', () => $next.removeClass('touch'))

    $prev.click(() => {
        slideTo(activeIndex <= 0 ? $items.length - 1 : activeIndex - 1, -1)
    })

    .on('touchstart', () => $prev.addClass('touch'))
    .on('touchend', () => $prev.removeClass('touch'))

    $mobileDots.eq(0).addClass('active')

    // Code made useless because the design team lead by Andrew was asked to change the spec by the owner of the company
    $(window).on('resize', () => {
        window.clearTimeout(timeout)

        timeout = window.setTimeout(() => {
            if (Modernizr.mq('(max-width: 1000px)')) {
                if (!isMobile) {
                    isMobile = true

                    // $buttons.each((btnIndex, button) => {
                    //     $(button).text($(button).data('text-mobile'))
                    // })

                    $next.add($prev).detach().appendTo($header)
                }
            } else if (isMobile) {
                isMobile = false

                // $buttons.each((btnIndex, button) => {
                //     $(button).text($(button).data('text-desktop'))
                // })

                $next.add($prev).detach().appendTo($sWindow)
            }
        }, 150)
    }).trigger('resize')
})



/** WEBPACK FOOTER **
 ** ./js/lib/slider.js
 **/